export function createReducer(initialState = {}, ...handlers) {
  const allHandlers = Object.assign({}, ...handlers);
  return function(state = initialState, action) {
    if (allHandlers.hasOwnProperty(action.type)) {
      return allHandlers[action.type](state, action);
    }
    return state;
  };
}

export function makeActionCreator(type, ...argNames) {
  return function(...args) {
    let action = { type };
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}

export function createSimpleKeyValueHandler(eventType) {
  return {
    [eventType]: function(state, action) {
      return action.data || null;
    },
  };
}

export function createSimpleKeyValueReducer(eventType, initialState) {
  return createReducer(initialState, createSimpleKeyValueHandler(eventType));
}

export function createSimpleToggleHandler(eventType) {
  return {
    [eventType]: function(state) {
      return !state;
    },
  };
}

export function createSimpleToggleReducer(eventType, initialState) {
  return createReducer(initialState, createSimpleToggleHandler(eventType));
}

export function createToggleAndSetReducer(toggleEvent, setEvent, initialState) {
  return createReducer(
    initialState,
    createSimpleToggleHandler(toggleEvent),
    createSimpleKeyValueHandler(setEvent)
  );
}

export function resetState(types, handler) {
  return (state, action) => {
    if (types.indexOf(action.type) !== -1) {
      state = undefined;
    }
    return handler(state, action);
  };
}
